/* @flow */
import {useQuery} from '@apollo/react-hooks';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetTeams as GetTeamsQuery} from 'nutshell-graphql-types';

import GET_TEAMS from '../queries/get-teams.graphql';

export const useGetTeams = (skip?: boolean) => {
    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetTeamsQuery, {}>(GET_TEAMS, {
        skip,
        fetchPolicy: 'cache-and-network',
    });

    const teams = data ? data.teams : null;

    return {
        teams: teams || [],
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    };
};
